// cosalpha brand wordmark — wordmark only, no glyph, no icon, no lockup.
// Per brand rules: "There is no symbol, no monogram, no glyph."
// Display flourish (italic Greek α as terminal "a") is permitted ONLY at ≥ 96pt.

export default function Logo({ size = 22, inverse = false, flourish = true, className = "" }) {
  const color = inverse ? "var(--cream)" : "var(--ink)";
  return (
    <span
      className={`font-serif inline-block ${className}`}
      style={{
        fontFamily: "'Source Serif 4', Georgia, serif",
        fontSize: size,
        fontWeight: 500,
        letterSpacing: "-0.025em",
        color,
        lineHeight: 1,
      }}
      data-testid="cosalpha-wordmark"
    >
      {flourish ? (
        <>
          cosalph
          <span style={{ fontStyle: "italic", color: "var(--saffron)" }}>α</span>
        </>
      ) : (
        "cosalpha"
      )}
    </span>
  );
}
